import { KeyEventListener } from '@usimweb/core/services';
import { BehaviorSubject } from 'rxjs';

export abstract class Dialog extends KeyEventListener {
  public saveResponse = new BehaviorSubject({});

  abstract save(event?: any): void;

  abstract close(): void;
}
